__turbopack_context__.v({
  "grid": "wiki-home-module__IF0bRa__grid",
  "heading": "wiki-home-module__IF0bRa__heading",
  "home": "wiki-home-module__IF0bRa__home",
  "land": "wiki-home-module__IF0bRa__land",
  "lead": "wiki-home-module__IF0bRa__lead",
  "list": "wiki-home-module__IF0bRa__list",
  "places": "wiki-home-module__IF0bRa__places",
  "preview": "wiki-home-module__IF0bRa__preview",
  "previewImage": "wiki-home-module__IF0bRa__previewImage",
  "topics": "wiki-home-module__IF0bRa__topics",
  "world": "wiki-home-module__IF0bRa__world",
});
